import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React__default from 'react';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';

function useMouseDrag(handleChange) {
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isMouseDown = _React$useState2[0],
    setIsMouseDown = _React$useState2[1];
  function handleMouseDown(e) {
    handleChange(e);
    setIsMouseDown(true);
  }
  function handleMouseUp() {
    setIsMouseDown(false);
  }
  var isDisabled = !isMouseDown;
  useEventListener(window, 'mousemove', handleChange, {
    isDisabled: isDisabled
  });
  useEventListener(window, 'mouseup', handleMouseUp, {
    isDisabled: isDisabled
  });
  return handleMouseDown;
}

export { useMouseDrag as default };
